import React from 'react';

const Bullhorn = props => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M27 15H31"
          stroke="#FCB200"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M25.2578 8.5L28.7218 6.5"
          stroke="#FCB200"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M25.2578 21.5L28.7218 23.5"
          stroke="#FCB200"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M12.147 22.018L14.798 27.959C15.291 29.064 14.795 30.36 13.69 30.853C12.585 31.346 11.289 30.85 10.796 29.745L5.5 18"
          stroke="#FCB200"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M21 25L11 18H5.5C3.015 18 1 15.985 1 13.5C1 11.015 3.015 9 5.5 9H11L21 2V25Z"
          stroke="#FCB200"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M7 9V18"
          stroke="#FCB200"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Bullhorn;



// WEBPACK FOOTER //
// ./src/svg/Bullhorn.js